<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown :popper-opts="popperOpt">
                <template slot="button-content">
                    <i class="famfamfam-silk cus-money"></i>
                    Billing
                </template>
                <b-dropdown-item
                    href="#0"
                    @click="showList(CBILLINGS.BILLING_TYPE.CREDITS)"
                >
                    <i class="famfamfam-silk cus-page-white-go"></i>
                    View Credits
                </b-dropdown-item>

                <b-dropdown-item
                    href="#0"
                    @click="showList(CBILLINGS.BILLING_TYPE.ESTIMATES)"
                >
                    <i class="famfamfam-silk cus-page-paste"></i>
                    View Estimates
                </b-dropdown-item>

                <dropdown-nested
                    :title="{
                        text: 'View Invoices',
                        icon: 'cus-page-white-stack'
                    }"
                    :list="invoiceChildDropdown"
                    @trigger-function="showInvoices"
                />

                <b-dropdown-item
                    href="#0"
                    @click="showList(CBILLINGS.BILLING_TYPE.LATE_FEES)"
                >
                    <i class="famfamfam-silk cus-clock-red"></i>
                    View Late Fees
                </b-dropdown-item>
                <b-dropdown-item
                    href="#0"
                    @click="showList(CBILLINGS.BILLING_TYPE.PAYMENTS)"
                >
                    <i class="famfamfam-silk cus-money"></i>
                    View Payments
                </b-dropdown-item>
                <b-dropdown-item
                    href="#0"
                    v-if="
                        (_isExtensionEnabled(
                            EXTENSIONS.CODE.CODE_CC_PROCESSING
                        ) ||
                            _isExtensionEnabled(
                                EXTENSIONS.CODE.CODE_CCONNECT
                            ) ||
                            _isExtensionEnabled(EXTENSIONS.CODE.CODE_GRAVITY) ||
                            _isExtensionEnabled(EXTENSIONS.CODE.CODE_STRIPE)) &&
                        _hasAccess('client.payment.method.view')
                    "
                    @click="showList('PAYMENT_METHODS')"
                >
                    <i class="famfamfam-silk cus-creditcards"></i>
                    View Payment Methods
                </b-dropdown-item>
                <b-dropdown-item
                    href="#0"
                    @click="showList(CBILLINGS.BILLING_TYPE.REFUNDS)"
                >
                    <i class="famfamfam-silk cus-money-refund"></i>
                    View Refunds
                </b-dropdown-item>
                <b-dropdown-item
                    href="#0"
                    @click="showList(CBILLINGS.BILLING_TYPE.RETURNS)"
                >
                    <i class="famfamfam-silk cus-page-refresh"></i>
                    View Returns
                </b-dropdown-item>
                <b-dropdown-item
                    href="#0"
                    @click="showList(CBILLINGS.BILLING_TYPE.WRITE_OFFS)"
                >
                    <i class="famfamfam-silk cus-page-white-put"></i>
                    View Write Offs
                </b-dropdown-item>
                <b-dropdown-item
                    href="#0"
                    @click="showList(CBILLINGS.BILLING_TYPE.DECLINED_ITEMS)"
                >
                    <i class="famfamfam-silk cus-pill-delete"></i>
                    View Declined Items
                </b-dropdown-item>
                <div class="dropdown-divider"></div>
                <dropdown-nested
                    :title="{
                        text: 'Account Statement',
                        icon: 'cus-page-white-stack'
                    }"
                    :list="accountStatementDropdown"
                    @trigger-function="sendStatement"
                />
                <div class="dropdown-divider"></div>
                <dropdown-nested
                    v-if="allowTransaction"
                    :title="{ text: 'New Transaction', icon: 'cus-add' }"
                    :list="newTransactionDropdown"
                    @trigger-function="addNewTransaction"
                />
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <list-credits
                v-if="selectedType == CBILLINGS.BILLING_TYPE.CREDITS"
            />
            <list-estimates
                v-if="selectedType == CBILLINGS.BILLING_TYPE.ESTIMATES"
            />
            <list-invoices
                v-if="isInvoice"
                :billing-type="selectedInvoice"
                :key="invoiceKey"
            />
            <list-declined
                v-if="selectedType == CBILLINGS.BILLING_TYPE.DECLINED_ITEMS"
            />
            <list-refunds
                v-if="selectedType == CBILLINGS.BILLING_TYPE.REFUNDS"
            />
            <list-returns
                v-if="selectedType == CBILLINGS.BILLING_TYPE.RETURNS"
            />
            <list-writeoffs
                v-if="selectedType == CBILLINGS.BILLING_TYPE.WRITE_OFFS"
            />
            <list-latefees
                v-if="selectedType == CBILLINGS.BILLING_TYPE.LATE_FEES"
            />
            <list-payments
                v-if="selectedType == CBILLINGS.BILLING_TYPE.PAYMENTS"
            />
            <list-payment-methods v-if="selectedType == 'PAYMENT_METHODS'" />
        </b-card-text>
    </b-tab>
</template>
<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import CBILLINGS from "@/constants/billings";
import EXTENSIONS from "@/constants/extensions";
import DropdownNested from "@/components/elements/dropdown/dropdown-nested";

export default {
    components: {
        DropdownNested,
        ListCredits: () => import("@/components/client-credits/credit-list"),
        ListEstimates: () =>
            import("@/components/client-estimates/estimate-list"),
        ListInvoices: () => import("@/components/client-invoices/invoice-list"),
        ListDeclined: () =>
            import("@/components/item-declined/item-declined-list"),
        ListRefunds: () => import("@/components/client-refunds/refund-list"),
        ListReturns: () => import("@/components/client-returns/return-list"),
        ListWriteoffs: () =>
            import("@/components/client-writeoffs/writeoff-list"),
        ListLatefees: () => import("@/components/client-latefees/latefee-list"),
        ListPayments: () => import("@/components/payments/payment-list"),
        ListPaymentMethods: () =>
            import("@/components/payment-methods/payment-method-list")
    },
    props: {
        openList: {
            default: null
        }
    },
    watch: {
        openList: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.showList(newValue);
                }
            }
        },
        dataLoaded: {
            immediate: true,
            deep: true,
            handler(newValue) {
                if (newValue) {
                    this.checkNewTransactionPermissions();
                }
            }
        },
        "$root.extensions": {
            immediate: true,
            deep: true,
            handler() {
                this.checkNewTransactionPermissions();
            }
        }
    },
    computed: {
        ...mapGetters({
            currentClient: "client/clientDetails"
        }),
        isInvoice() {
            var invoiceTypes = [
                CBILLINGS.BILLING_TYPE.ALL_INVOICES,
                CBILLINGS.BILLING_TYPE.LOCKED_INVOICES,
                CBILLINGS.BILLING_TYPE.OPEN_INVOICES,
                CBILLINGS.BILLING_TYPE.REOPENED_INVOICES,
                CBILLINGS.BILLING_TYPE.PAID_INVOICES
            ];
            return _.indexOf(invoiceTypes, this.selectedType) != -1;
        },
        dataLoaded() {
            return !_.isEmpty(this.$root.permissions);
        },
        statusActive() {
            return this.$store.getters["client/statusActive"];
        }
    },
    data() {
        return {
            invoiceChildDropdown: [
                {
                    text: "View All Invoices",
                    icon: "famfamfam-silk cus-page-white-stack",
                    function_code: CBILLINGS.BILLING_TYPE.ALL_INVOICES
                },
                {
                    text: "View Locked Invoices",
                    icon: "famfamfam-silk cus-page-white-key",
                    function_code: CBILLINGS.BILLING_TYPE.LOCKED_INVOICES
                },
                {
                    text: "View Open Invoices",
                    icon: "famfamfam-silk cus-page-white-error",
                    function_code: CBILLINGS.BILLING_TYPE.OPEN_INVOICES
                },
                {
                    text: "View Reopen Invoices",
                    icon: "famfamfam-silk cus-page-white-error",
                    function_code: CBILLINGS.BILLING_TYPE.REOPENED_INVOICES
                },
                {
                    text: "View Paid Invoices",
                    icon: "famfamfam-silk cus-folder-page-white",
                    function_code: CBILLINGS.BILLING_TYPE.PAID_INVOICES
                }
            ],
            accountStatementDropdown: [
                {
                    text: "Email Statement",
                    icon: "cus-email",
                    function_code: "EMAIL",
                    isModal: true
                },
                {
                    text: "Print Statement",
                    icon: "cus-printer",
                    function_code: "PRINT",
                    isModal: true
                }
            ],
            newTransactionDropdown: [],
            CBILLINGS,
            EXTENSIONS,
            selectedType: CBILLINGS.BILLING_TYPE.CREDITS, // default CBILLINGS.BILLING_TYPE.CREDITS
            selectedInvoice: CBILLINGS.BILLING_TYPE.ALL_INVOICES,
            invoiceKey: 0,
            allowTransaction: true,
            popperOpt: {
                placement: "bottom-start",
                modifiers: {
                    flip: {
                        enabled: false
                    }
                },
                positionFixed: true
            }
        };
    },
    mounted() {},
    methods: {
        showList(billingType) {
            this.selectedType = billingType;
        },
        showInvoices(type) {
            this.invoiceKey++;
            this.selectedType = type;
            this.selectedInvoice = type;
        },
        sendStatement(code) {
            if (code == "EMAIL") {
                this.$parent.$parent.$refs.modalEmailStatement.open();
            } else {
                this.$parent.$parent.$refs.modalPrintStatement.open();
            }
        },
        addNewTransaction(code) {
            if (code == "ESTIMATE") {
                this.$parent.$parent.$refs.modalNewEstimate.open();
            } else if (code == "PAYMENT_METHOD") {
                this.$parent.$parent.$refs.modalNewPaymentMethod.open({
                    client: this.currentClient,
                    trans_type: "payment_method",
                    entity: "client"
                });
            } else if (code == "INVOICE") {
                this.$parent.$parent.$refs.modalNewInvoice.open();
            }
        },
        showEmailStatementModal() {
            this.$parent.$parent.$refs.modalEmailStatement.open();
        },
        checkNewTransactionPermissions() {
            this.newTransactionDropdown = [];

            if (this._hasAccess("billing.estimate.create")) {
                this.newTransactionDropdown.push({
                    text: "New Estimate",
                    icon: "cus-add",
                    function_code: "ESTIMATE",
                    isModal: true
                });
            }

            let checkBillingPermission = this._hasAccess(
                "billing.invoice.create"
            );
            checkBillingPermission = _.isUndefined(checkBillingPermission)
                ? true
                : checkBillingPermission;

            if (checkBillingPermission) {
                this.newTransactionDropdown.push({
                    text: "New Invoice",
                    icon: "cus-add",
                    function_code: "INVOICE",
                    isModal: true
                });
            }

            if (
                (this._isExtensionEnabled(EXTENSIONS.CODE.CODE_CC_PROCESSING) ||
                    this._isExtensionEnabled(EXTENSIONS.CODE.CODE_CCONNECT) ||
                    this._isExtensionEnabled(EXTENSIONS.CODE.CODE_GRAVITY) ||
                    this._isExtensionEnabled(EXTENSIONS.CODE.CODE_STRIPE)) &&
                this._hasAccess("client.payment.method.add")
            ) {
                this.newTransactionDropdown.push({
                    text: "New Payment Method",
                    icon: "cus-add",
                    function_code: "PAYMENT_METHOD",
                    isModal: true
                });
            }

            this.allowTransaction =
                (this._hasAccess("billing.estimate.create") ||
                    this._hasAccess("billing.invoice.create") ||
                    this._hasAccess("client.payment.method.add")) &&
                this.statusActive;
        }
    }
};
</script>
